import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import { Formik, Form, Field } from "formik";
import {
  getAccountProfile,
  getCountryList,
  getCustomerCareCategory,
  getGamesSearch,
  getUserContestList,
  ticketUpload,
} from "../../../Utilities/controller";
import { func } from "../../../Utilities/logFunc";
import { url } from "../../../Utilities/url";
import moment from "moment";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { json, useNavigate } from "react-router";

import * as Yup from "yup";
import DropDown from "../../Common/DropDown";
import CountryDropDown from "../../Common/CountryListDropDown";
import CategoryDropDown from "../../Common/CategoryDropDown";
import GameDropDown from "./GameDropDown";
import { useTranslation } from "react-i18next";
import {eventTracking} from "../../../firebaseAnalytics"; 
import { events } from "../../../Utilities/appEvents"; 
import Loader from "../../Common/Loader";
import { addTicket } from "../../../Utilities/withJwtController";

const CustomerCareForm = () => {
  let premiumUser = JSON.parse(localStorage.getItem("premiumUser"));
  const {t} = useTranslation()

  const [userDataInfo, setUserData] = useState(undefined);
  const [countryList, setCountryList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [games, setGames] = useState([]);
  const [match, setMatch] = useState([]);
  const [uploadedImage, setUploadedImage] = useState(null);
  const [showMobileMOdal, setShowModal] = useState(false);
  const [mobileNo, setMobileNo] = useState("");
  const [showTimeSlot, setShowTimeSlot] = useState(false);
  const [showCallbackConfirmation, setShowCallbackConfirmation] =
    useState(false);
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [requestPayload, setRequestPayload] = useState(null);
  const [activeGame, setActiveGame] = useState("");
  const [frmInitialValues, setFrmInitialValues] = useState({
    userName: "",
    countryCode: "",
    mobileNumber: "",
    emailId: "",
    category: "",
    categoryName: "",
    subCategory: "",
    subCategoryName: "",
    game: "",
    match: "",
    matchName: "",
    isSingle: false,
    description: "",
    isContestDependency: false,
  });
  const [isLoading, setLoading] = useState(false);

  const [gameError, setGameError] = useState({
    status: false,
    message: t('game_is_require'),
  });
  const [matchError, setMatchError] = useState({
    status: false,
    message: t('match_is_require'),
  });

  const [mobileError, setMobileError] = useState({
    status: false,
    message: t('error_Please_enter_the_phone_number'),
  });
  const [emailError, setEmailError] = useState({
    status: false,
    message: t('error_please_enter_email'),
  });

  const navigate = useNavigate();

  useEffect(() => {
    // getAccountProfileDetails();

    let userData = JSON.parse(localStorage.getItem("profile"));
    setUserData(userData);
    // fetchCountry();
    fetchCategory();
  }, []);

  useEffect(() => {
    let formdata = { ...frmInitialValues };
    formdata.userName = userDataInfo?.item?.gamerjiName;
    formdata.mobileNumber = userDataInfo?.item?.phone;
    formdata.emailId = userDataInfo?.item?.email;

    // let newArray = countryList.filter(function (el) {
    //   return el?.dialingCode === userDataInfo?.item?.phoneCode;
    // });

    // if (newArray?.length && newArray?.length > 0) {
    formdata.countryCode = userDataInfo?.item?.phoneCode || userDataInfo?.country?.dialingCode;
    // }

    setFrmInitialValues(formdata);
  }, [userDataInfo]);

  const getAccountProfileDetails = async () => {
    // try {
    //   const res = await getAccountProfile();
    //   if (res?.data) {
    //     setUserData(res?.data);
    //   }
    //   func(res);
    // } catch (error) {
    //   func("avatar 13", error?.response?.data?.errors?.[0]?.msg);
    // }
  };

  // const fetchCountry = async () => {
  //   try {
  //     const res = await getCountryList();
  //     setCountryList((prev) => [...res?.list]);
  //   } catch (error) {
  //     func("error", error);
  //   }
  // };

  const fetchCategory = async () => {
    try {
      let data = {
        search: {
          onlyActive: true,
          isParent: true,
        },
        pagination: {
          pageNo: 1,
          recordPerPage: 100,
        },
      };

      const res = await getCustomerCareCategory(data);
      setCategoryList(res?.data?.data);
    } catch (error) {
      toast.error(error?.response?.data?.errors[0]?.msg);
      func("error", error);
    }
  };

  const fetchSubCategory = async (id) => {
    try {
      let data = {
        search: {
          onlyActive: true,
          parent: id,
        },
        pagination: {
          pageNo: 1,
          recordPerPage: 100,
        },
      };

      const res = await getCustomerCareCategory(data);
      setSubCategoryList(res?.data?.data);
    } catch (error) {
      func("error", error);
    }
  };

  const fetchGames = async () => {
    try {
      const res = await getGamesSearch();
      setGames(res?.data?.list);
    } catch (error) {
      func("error", error);
    }
  };

  const fetchContests = async (id) => {
    let profile= JSON.parse(localStorage.getItem('profile'))
    //console.log("GAME CHanged",value,profile.item._id)
    try {
      let data = {
        game: id,
        user_id: userDataInfo?.item?.user_id || profile?.item?.user_id,
      };

      const res = await getUserContestList(data);
      setMatch(res?.data?.list);
    } catch (error) {
      func("error", error);
    }
  };

  const uploadTicketImage = async (data) => {
    try {
      const res = await ticketUpload(data);
      setUploadedImage(res?.data?.item);
      toast.success(t("crm.success_image_upload"));
    } catch (error) {
      func("error", error);
      toast.error(error?.message);
    }
  };

  const handleChangeCategory = (value) => {
    let formdata = { ...frmInitialValues };
    if (
      value &&
      value != "" &&
      value != undefined &&
      value != null &&
      value != "undefined" &&
      value != "null"
    ) {
      let newArray = categoryList.filter(function (el) {
        return el?._id === value;
      });

      let categoryName = "";
      if (newArray?.length && newArray?.length > 0) {
        categoryName = newArray[0]?.label;
      }

      fetchSubCategory(value);
      formdata.category = value;
      formdata.categoryName = categoryName;
    } else {
      setSubCategoryList([]);
    }

    formdata.subCategory = "";
    formdata.subCategoryName = "";
    formdata.game = "";
    formdata.match = "";
    formdata.matchName = "";
    formdata.isSingle = false;
    setFrmInitialValues(formdata);
  };

  const handleChangeSubCategory = (value) => {
    let formdata = { ...frmInitialValues };
    if (
      value &&
      value != "" &&
      value != undefined &&
      value != null &&
      value != "undefined" &&
      value != "null"
    ) {
      let newArray = subCategoryList.filter(function (el) {
        return el?._id === value;
      });

      let isContestDependency = false,
        subCategoryName = "";
      if (newArray?.length && newArray?.length > 0) {
        isContestDependency = newArray[0]?.isContestDependency;
        subCategoryName = newArray[0]?.label;
      }

      formdata.subCategory = value;
      formdata.isContestDependency = isContestDependency;
      formdata.subCategoryName = subCategoryName;

      if (isContestDependency) {
        fetchGames();
      }
    } else {
      setGames([]);
    }

    formdata.game = "";
    formdata.match = "";
    formdata.matchName = "";
    formdata.isSingle = false;
    setFrmInitialValues(formdata);
  };

  const handleChangeGame = (value) => {
    let profile= JSON.parse(localStorage.getItem('profile'))
    // console.log("GAME CHanged",value,profile.item._id)
    setMatch([]);
    let formdata = { ...frmInitialValues };
    if (
      value &&
      value != "" &&
      value != undefined &&
      value != null &&
      value != "undefined" &&
      value != "null"
    ) {
      // console.log("*******here")
      fetchContests(value);
      formdata.game = value;
      formdata.user_id=profile?.item?._id||null
    } else {
      setMatch([]);
    }

    let formdataError1 = { ...gameError };
    formdataError1.status = false;
    setMatchError(formdataError1);

    let formdataError = { ...matchError };
    formdataError.status = false;
    setMatchError(formdataError);

    formdata.match = "";
    formdata.matchName = "";
    formdata.isSingle = false;
    setFrmInitialValues(formdata);
  };

  const uploadImage = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      uploadTicketImage(img);
    }
  };

  const customerCareSchema = Yup.object().shape({
    userName: Yup.string(),
    countryCode: Yup.string().required(t('country_code_is_require')),
    // mobileNumber: Yup.string()
    //   .min(8)
    //   .max(15)
    //   .required(t('mobile_is_require')),
    emailId: Yup.string()
    .email(t('enter_valid_email'))
    .required(t('email_is_require')),
    category: Yup.string().required(t('category_is_require')),
    subCategory: Yup.string().required(t('sub_category_is_require')),
    description: Yup.string().required(t('description_is_require')),
  });

  const handleSubmit = async (values) => {
    // console.log("*********************Submit",values)
    func("crm", "submit");
    let error = false;
    if(values?.mobileNumber){
      if (
        values?.countryCode == "" ||
        values?.countryCode == null ||
        values?.countryCode == "null" ||
        values?.countryCode == undefined ||
        values?.countryCode == "undefined"
      ) {
        error = true;
      }
    }
    if (
      (values?.mobileNumber == "" && values?.emailId == "") ||
      (values?.mobileNumber == null && values?.emailId == null) ||
      (values?.mobileNumber == "null" && values?.emailId == "null") ||
      (values?.mobileNumber == undefined && values?.emailId == undefined)||
      (values?.mobileNumber == "undefined" && values?.emailId ==  "undefined")
    ) {
      // console.log("*******here")
      error = true;
    }

    if (
      (values?.mobileNumber == "" && !values?.emailId == "") ||
      (values?.mobileNumber == null && !values?.emailId == null) ||
      (values?.mobileNumber == "null" && !values?.emailId == "null") ||
      (values?.mobileNumber == undefined && !values?.emailId == undefined)||
      (values?.mobileNumber == "undefined" && !values?.emailId ==  "undefined")
    ) {
      error = true;
      let formdata = { ...mobileError };
      formdata.status = true;
      setMobileError(formdata);
    } else {
      let formdata = { ...mobileError };
      formdata.status = false;
      setMobileError(formdata);
    }

    if (
      (!values?.mobileNumber == "" && values?.emailId == "") ||
      (!values?.mobileNumber == null && values?.emailId == null) ||
      (!values?.mobileNumber == "null" && values?.emailId == "null") ||
      (!values?.mobileNumber == undefined && values?.emailId == undefined)||
      (!values?.mobileNumber == "undefined" && values?.emailId ==  "undefined")
    ) {
      error = true;
      let formdata = { ...emailError };
      formdata.status = true;
      setEmailError(formdata);
    } else {
      let formdata = { ...emailError };
      formdata.status = false;
      setEmailError(formdata);
    }

    // if (
    //   values?.emailId == "" ||
    //   values?.emailId == null ||
    //   values?.emailId == "null" ||
    //   values?.emailId == undefined ||
    //   values?.emailId == "undefined"
    // ) {
    //   error = true;
    // }
    if (
      values?.category == "" ||
      values?.category == null ||
      values?.category == "null" ||
      values?.category == undefined ||
      values?.category == "undefined"
    ) {
      error = true;
    }
    if (
      values?.subCategory == "" ||
      values?.subCategory == null ||
      values?.subCategory == "null" ||
      values?.subCategory == undefined ||
      values?.subCategory == "undefined"
    ) {
      error = true;
    }
    if (values?.isContestDependency) {          
      if (
        values?.game != "" &&
        values?.game != null &&
        values?.game != "null" &&
        values?.game != undefined &&
        values?.game != "undefined"
      ) {
        let formdata = { ...gameError };
        formdata.status = false;
        setGameError(formdata);
        error = false;
      } else {
        let formdata = { ...gameError };
        formdata.status = true;
        setGameError(formdata);
        error = true;
      }
      if (
        values?.match != "" &&
        values?.match != null &&
        values?.match != "null" &&
        values?.match != undefined &&
        values?.match != "undefined"
      ) {
        let formdata = { ...matchError };
        formdata.status = false;
        setMatchError(formdata);
        error = false;
      } else {
        let formdata = { ...matchError };
        formdata.status = true;
        setMatchError(formdata);
        error = true;
      }
    }
    if (
      frmInitialValues?.description == "" ||
      frmInitialValues?.description == null ||
      frmInitialValues?.description == "null" ||
      frmInitialValues?.description == undefined ||
      frmInitialValues?.description == "undefined"
    ) {
      error = true;
    }
    
    if (!error) {
      let data = {
        name: values.userName,
        email: values.emailId,
        phone: values.mobileNumber,
        phoneCode: values.phoneCode,
        category: values.category,
        description: frmInitialValues.description,
        customerCareCategoryName: values.categoryName,
        userPlatform: "webportal",
        userVersion: "1.0",
      };

      if (values?.subCategory) {
        data["subCategory"] = values?.subCategory;
        data["subCategoryName"] = values?.subCategoryName;
      }

      if (games.length > 0) {
        if (values?.game) {
          data["game"] = values?.game;
        }
        if (values?.match) {
          data["gametype"] = values?.match;
          data["isSingle"] = values?.isSingle;
          data["gametypeName"] = values?.matchName; //
        }
      }

      if (uploadedImage && uploadedImage?.screenShot) {
        data["screenShot"] = uploadedImage?.screenShot;
      }

      try {
        setLoading(true)
        const res = await addTicket(data);

        if (res?.data?.success) {
        eventTracking(events.Raise_a_Complaint,{GJ_TicketID:res?.data?._id});

          toast.success(t("crm.your_request_has_been_submitted_succesfully"));
          navigate("/home/customer-care");
        } else {
          setLoading(false)
          toast.error(res?.data?.errors?.[0]?.msg);
        }
        func(res);
      } catch (error) {
        setLoading(false)
        toast.error(error?.response?.data?.errors?.[0]?.msg);
      }
    }
  };

  const handlerRequest = async (values) => {
    console.log("handlerRequest",values)
    func("crm", "submit");
    let error = false;
    if (
      values?.countryCode == "" ||
      values?.countryCode == null ||
      values?.countryCode == "null" ||
      values?.countryCode == undefined ||
      values?.countryCode == "undefined"
    ) {
      error = true;
    }
    if (
      (values?.mobileNumber == "") ||
      (values?.mobileNumber == null) ||
      (values?.mobileNumber == "null") ||
      (values?.mobileNumber == undefined)||
      (values?.mobileNumber == "undefined")
    ) {
      let formdata = { ...mobileError };
      formdata.status = true;
      setMobileError(formdata);
      error = true;
    } else {
      let formdata = { ...mobileError };
      formdata.status = false;
      setMobileError(formdata);
    }

    if (
      (values?.emailId == "") ||
      (values?.emailId == null) ||
      (values?.emailId == "null") ||
      (values?.emailId == undefined)||
      (values?.emailId ==  "undefined")
    ) {
      let formdata = { ...emailError };
      formdata.status = true;
      setEmailError(formdata);
      error = true;
    } else {
      let formdata = { ...emailError };
      formdata.status = false;
      setEmailError(formdata);
    }
    if (
      values?.category == "" ||
      values?.category == null ||
      values?.category == "null" ||
      values?.category == undefined ||
      values?.category == "undefined"
    ) {
      error = true;
    }
    if (
      values?.subCategory == "" ||
      values?.subCategory == null ||
      values?.subCategory == "null" ||
      values?.subCategory == undefined ||
      values?.subCategory == "undefined"
    ) {
      error = true;
    }

    if (values?.isContestDependency) {
      if (
        values?.game != "" &&
        values?.game != null &&
        values?.game != "null" &&
        values?.game != undefined &&
        values?.game != "undefined"
      ) {

        let formdata = { ...gameError };
        formdata.status = false;
        setGameError(formdata);
        error = false;
      } else {

        let formdata = { ...gameError };
        formdata.status = true;
        setGameError(formdata);
        error = true;
      }
      if (
        values?.match != "" &&
        values?.match != null &&
        values?.match != "null" &&
        values?.match != undefined &&
        values?.match != "undefined"
      ) {
        let formdata = { ...matchError };
        formdata.status = false;
        setMatchError(formdata);
        error = false;
      } else {
        let formdata = { ...matchError };
        formdata.status = true;
        setMatchError(formdata);
        error = true;
      }
    }
    if (
      values?.description == "" ||
      values?.description == null ||
      values?.description == "null" ||
      values?.description == undefined ||
      values?.description == "undefined"
    ) {
      error = true;
    }
    // console.log("error",error)
    if (!error) {
      let data = {
        name: values.userName,
        email: values.emailId,
        phone: values.mobileNumber,
        phoneCode: userDataInfo?.country?.dialingCode,
        category: values.category,
        description: values.description,
        customerCareCategoryName: values.categoryName,
        userPlatform: "webportal",
        userVersion: "1.0",
      };

      if (values?.subCategory) {
        data["subCategory"] = values?.subCategory;
        data["subCategoryName"] = values?.subCategoryName;
      }

      if (games.length > 0) {
        if (values?.game) {
          data["game"] = values?.game;
        }
        if (values?.match) {
          data["gametype"] = values?.match;
          data["isSingle"] = values?.isSingle;
          data["gametypeName"] = values?.matchName; //
        }
      }

      if (uploadedImage && uploadedImage?.screenShot) {
        data["screenShot"] = uploadedImage?.screenShot;
      }
      setMobileNo(values.mobileNumber);
      setShowModal(true);
      setRequestPayload(data);
      // try {
      //   const res = await addTicket(data);
      //   if (res?.data?.success) {
      //     toast.success("Your ticket raise successfully.");
      //     navigate("/home/customer-care");
      //   } else {
      //     toast.error(res?.data?.errors?.[0]?.msg);
      //   }
      //   func(res);
      // } catch (error) {
      //   toast.error(error?.response?.data?.errors?.[0]?.msg);
      // }
      eventTracking(events.REQUEST_CALL_BACK,{
        
      });
    }
  };

  useEffect(() => {
    console.log("frmInitialValues",frmInitialValues)
  },[frmInitialValues])

  return (
    <div class="col-12">
      {/* <ToastContainer /> */}
      <div class="mb-5 pb-3">
        <h2 class="h3 bodyExtraBoldFont mb-0 text-dark">{t('crm.details')}</h2>
      </div>
      {isLoading ?  <Loader /> : <></>}
      <Formik
        type="submit"
        enableReinitialize={true}
        initialValues={frmInitialValues}
        validationSchema={customerCareSchema}
      >
        {({
          // handleSubmit,
          errors,
          values,
          // setFieldValue,
          // validateField,
          // validateForm,
        }) => (
          <Form>
            <div class="row gx-4 gy-5 mb-5 customerCareForm">
              <div class="col-lg-4 col-md-6">
                <label for="inputEmail4" class="form-label h5 mb-3">
                {t('crm.gamerji_name')}
                </label>
                <Field
                  type="text"
                  class="form-control custom-input"
                  id="inputEmail4"
                  placeholder={t('Profile.gamerji_username',{name:'Gamerji'})}
                  name="userName"
                  readOnly={true}
                />
                {errors.userName ? (
                  <div className="error">{errors.userName}</div>
                ) : null}
              </div>

              {/* {console.log("userDataInfo************************************************",userDataInfo)} */}

              {userDataInfo?.item?.email ?
              (
              <div class="col-lg-4 col-md-6">
                <label for="inputEmail4" class="form-label h5 mb-3">
                {t('crm.email')}
                </label>
                <Field
                  type="text"
                  class={`form-control ${userDataInfo?.item?.isEmailVerified ? "custom-input" : ""}`}
                  id="inputEmail4"
                  placeholder={t('crm.enter_email')}
                  name="emailId"
                  readOnly={userDataInfo?.item?.isEmailVerified ? true : false}
                  onChange = {(e) => {
                    setFrmInitialValues({
                      ...frmInitialValues,
                      emailId: e.target.value
                    });
                  }}
                />
                {emailError.status ? (
                    <div className="error">{emailError.message}</div>
                  ) : null}
              </div>):
              (
                <div class="col-lg-4 col-md-6">
                  <label for="inputEmail4" class="form-label h5 mb-3">
                  {t('crm.email')}
                  </label>
                  <Field
                    type="text"
                    class={`form-control ${userDataInfo?.item?.isEmailVerified ? "custom-input" : ""}`}
                    id="inputEmail4"
                    placeholder={t('crm.enter_email')}
                    name="emailId"
                    readOnly={userDataInfo?.item?.isEmailVerified ? true : false}
                    onChange = {(e) => {
                      setFrmInitialValues({
                        ...frmInitialValues,
                        emailId: e.target.value
                      });
                    }}
                  />
                  {emailError.status ? (
                      <div className="error">{emailError.message}</div>
                    ) : null}
                </div>)
              }
              {userDataInfo?.item?.phone ? (
              <div class="col-lg-4 col-md-6">
                <div className="row">
                  {!userDataInfo?.item?.isMobileVerified && <div className="col-4">
                      <label
                        for="inputCoutryCode"
                        className="form-label text-nowrap "
                      >
                      {t('Profile.country_code')}
                      </label>
                      <div
                        class={`input-group w-auto d11-phoneCode form-select select d11-phone-code`}
                        style={{ backgroundColor: "var(--secondary-color-emphasis)", border:'none' ,color:"var(--color-black)", opacity: "1" }}
                      >
                        <img
                          className="icon-24"
                          style={{ borderRadius: "50%" }}
                          src={
                            url.imageUrl +
                            userDataInfo?.country
                              ?.flag?.default
                          }
                          alt=""
                        />
                        <div
                          name=""
                          id=""
                          // class="form-control form-control-sm  "
                          style={{
                            maxWidth: "50px",
                            alignItems: "center",
                            padding: " 0 5px",
                            display: "flex",
                            alignItems: "center",
                          }}
                          disabled={true}
                        >
                          {userDataInfo?.country?.dialingCode}
                        </div>
                      </div>
                  </div>}
                  <div className={!userDataInfo?.item?.isMobileVerified && "col-8"}>
                  <label for="inputEmail4" class="form-label h5 mb-3">
                    {t('crm.mobile_number')}
                  </label>
                    <Field
                      type="text"
                      class={`form-control ${userDataInfo?.item?.isMobileVerified ? "custom-input" : ""}`}
                      id="inputEmail4"
                      placeholder={t('crm.enter_mobile_number')}
                      name="mobileNumber"
                      value={!userDataInfo?.item?.isMobileVerified ? values.mobileNumber : values?.countryCode + " - " + values.mobileNumber}
                      readOnly={
                        userDataInfo?.item?.isMobileVerified ? true : false
                      }
                      onChange = {(e) => {
                        setFrmInitialValues({
                          ...frmInitialValues,
                          countryCode: userDataInfo?.country?.dialingCode,
                          mobileNumber: e.target.value
                        });
                      }}
                    />

                  {mobileError.status ? (
                    <div className="error">{mobileError.message}</div>
                  ) : null}
                  </div>

                </div>
              </div> ) : (
                <div class="col-lg-4 col-md-6">
                  <div className={`row  mb-3 text-dark d11-profile-form`}>
                    <div className="col-4">
                      <label
                        for="inputCoutryCode"
                        className="form-label text-nowrap "
                      >
                      {t('Profile.country_code')}
                      </label>
                      <div
                        class={`input-group w-auto d11-phoneCode form-select select d11-phone-code`}
                        style={{ backgroundColor: "var(--secondary-color-emphasis)", border:'none' ,color:"var(--color-black)", opacity: "1" }}
                      >
                        <img
                          className="icon-24"
                          style={{ borderRadius: "50%" }}
                          src={
                            url.imageUrl +
                            userDataInfo?.country
                              ?.flag?.default
                          }
                          alt=""
                        />
                        <div
                          name=""
                          id=""
                          // class="form-control form-control-sm  "
                          style={{
                            maxWidth: "50px",
                            alignItems: "center",
                            padding: " 0 5px",
                            display: "flex",
                            alignItems: "center",
                          }}
                          disabled={true}
                        >
                          {userDataInfo?.country?.dialingCode}
                        </div>
                      </div>
                    </div>
                    <div className="col-8">
                      <label for="inputMobileNumber" className="form-label">
                      {t('Profile.mobile_number')}
                      </label>
                      <Field
                        type="text"
                        class={`form-control ${userDataInfo?.item?.isMobileVerified ? "custom-input" : ""}`}
                        id="inputEmail4"
                        placeholder={t('crm.enter_mobile_number')}
                        name="mobileNumber"
                        value={values?.mobileNumber}
                        onKeyDown={(e) =>
                          ["e", "E", "+", "-","."].includes(e.key) &&
                          e.preventDefault()
                        }
                        onChange = {(e) => {
                          setFrmInitialValues({
                            ...frmInitialValues,
                            countryCode: userDataInfo?.country?.dialingCode,
                            mobileNumber: e.target.value
                          });
                        }}
                      />

                  {mobileError.status ? (
                    <div className="error">{mobileError.message}</div>
                  ) : null}
                    </div>
                  </div>
                </div>
              )
              }
              {/* {(!userDataInfo?.item?.email && !userDataInfo?.item?.phone)&&(<>
                <div class="col-lg-4 col-md-6">
                  <label for="inputEmail4" class="form-label h5 mb-3">
                    {t('crm.email')}
                  </label>
                  <Field
                    type="text"
                    class={`form-control ${userDataInfo?.item?.isEmailVerified ? "custom-input" : ""}`}
                    id="inputEmail4"
                    placeholder={t('crm.enter_email')}
                    name="emailId"
                    readOnly={userDataInfo?.item?.isEmailVerified ? true : false}
                  />
                  {emailError.status ? (
                    <div className="error">{emailError.message}</div>
                  ) : null}
                </div>
                <div class="col-lg-4 col-md-6">
                <label for="inputEmail4" class="form-label h5 mb-3">
                {t('crm.email')}
                </label>
                <Field
                  type="text"
                  class={`form-control ${userDataInfo?.item?.isEmailVerified ? "custom-input" : ""}`}
                  id="inputEmail4"
                  placeholder={t('crm.enter_email')}
                  name="emailId"
                  readOnly={userDataInfo?.item?.isEmailVerified ? true : false}
                />
                {emailError.status ? (
                    <div className="error">{emailError.message}</div>
                  ) : null}
              </div></>
                
              )} */}

              


              <div class="col-lg-4 col-md-6 formDropdown ticket-category-dropdown">
                <label for="inputEmail4" class="form-label h5 mb-3">
                {t('crm.category')}
                </label>
                {/* <select
                  className="form-select select dropdown-toggle"
                  name="category"
                  onChange={handleChangeCategory}
                  value={frmInitialValues?.category}
                >
                  <option
                    className="dropdown-item"
                    disabled={frmInitialValues?.category && true}
                    selected={true}
                  >
                    Select Category
                  </option>
                  {categoryList?.length > 0 ? (
                    categoryList?.map((ele, index) => (
                      <option className="dropdown-item" value={ele?._id}>
                        {ele?.label}
                      </option>
                    ))
                  ) : (
                    <></>
                  )}
                </select> */}
                <CategoryDropDown
                  options={categoryList}
                  handleChnage={(value) => handleChangeCategory(value)}
                />

                {errors.category ? (
                  <div className="error">{errors.category}</div>
                ) : null}
              </div>
              {subCategoryList?.length > 0 && (
                <div class="col-lg-4 col-md-6 formDropdown ticket-category-dropdown">
                  <label for="inputEmail4" class="form-label h5 mb-3">
                  {t('crm.sub_category')}
                  </label>
                  {/* <select
                    className="form-select select dropdown-toggle"
                    name="subCategory"
                    onChange={handleChangeSubCategory}
                    value={frmInitialValues?.subCategory}
                  >
                    <option
                      disabled={frmInitialValues?.subCategory && true}
                      selected={true}
                    >
                      Select Sub Category
                    </option>
                    {subCategoryList?.length > 0 ? (
                      subCategoryList?.map((ele, index) => (
                        <option
                          value={ele?._id}
                          data-isContestDependency={ele?.isContestDependency}
                        >
                          {ele?.label}
                        </option>
                      ))
                    ) : (
                      <></>
                    )}
                  </select> */}
                  <CategoryDropDown
                    options={subCategoryList}
                    handleChnage={(value) => handleChangeSubCategory(value)}
                  />
                  {errors.subCategory ? (
                    <div className="error">{errors.subCategory}</div>
                  ) : null}
                </div>
              )}
              {games?.length > 0 && (
                <div class="col-lg-4 col-md-6 formDropdown ticket-category-dropdown">
                  <label for="inputEmail4" class="form-label h5 mb-3">
                  {t('crm.games')}
                  </label>
                  {/* <select
                    className="form-select select dropdown-toggle"
                    name="game"
                    onChange={handleChangeGame}
                    value={frmInitialValues?.game}
                  >
                    <option
                      disabled={frmInitialValues?.game && true}
                      selected={true}
                    >
                      Select Game
                    </option>
                    {games?.length > 0 ? (
                      games?.map((ele, index) => (
                        <option value={ele?._id}>{ele?.name}</option>
                      ))
                    ) : (
                      <></>
                    )}
                  </select> */}
                  <GameDropDown
                    options={games}
                    handleChnage={(value) => handleChangeGame(value)}
                  />
                  {gameError.status ? (
                    <div className="error">{gameError.message}</div>
                  ) : null}
                </div>
              )}
            </div>
            {match?.length > 0 && (
              <div class="row gx-4 gy-5">
                <div class="col-lg-12">
                  <label for={`inputEmail4`} class="form-label h5 mb-3">
                  {t('crm.select_match')}
                  </label>
                  {/* {matchError.status ? <div>{matchError.message}</div> : null} */}
                  {match?.length > 0 ? (
                    match?.map((ele, index) => (
                      <div
                        class="d-flex flex-column text-start mb-3 pt-2"
                        key={index}
                      >
                        <div class="form-check">
                          <input
                            class="form-check-input"
                            type="radio"
                            name="match"
                            id={`flexRadioDefault${index}`}
                            value={ele?.gameType?._id}
                            checked={activeGame == ele?._id}
                            onChange={() => {
                              // console.log("clikced***********",ele?._id)
                              // let newArray = match.filter(function (el) {
                              //   return ele?.gameType?._id === e?.target?.value;
                              // });

                              let formdata = { ...frmInitialValues };
                              setActiveGame(ele?._id);
                              // if (newArray?.length && newArray?.length > 0) {
                              formdata.matchName = ele?.gameType?.name;
                              formdata.isSingle = ele?.isSingle;
                              // }

                              formdata.match = ele?._id;
                              setFrmInitialValues(formdata);

                              let formdataError1 = { ...gameError };
                              formdataError1.status = false;
                              setMatchError(formdataError1);

                              let formdataError = { ...matchError };
                              formdataError.status = false;
                              setMatchError(formdataError);
                            }}
                          />
                          <label
                            class="form-check-label"
                            for={`flexRadioDefault${index}`}
                          >
                            {ele?.gameType?.name} {" - "}{" "}
                            {moment(ele?.date).format("DD/MM/YYYY")} {" - "}{" "}
                            {moment(ele?.time).format("hh:mm A")} {" - "}{" "}
                            {ele?.isSingle === false ? "Tournament" : "Contest"}
                          </label>
                          {/* {console.log("match status**********", matchError)} */}
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="error">{t('notFound.no_match_found')}</div>
                  )}
                  {matchError.status ? (
                    <div className="error">{matchError.message}</div>
                  ) : null}
                </div>
              </div>
            )}

            {games?.length > 0 &&
              frmInitialValues?.game != "" &&
              match?.length == 0 && (
                <div className="error mb-5">{t('match_record_not_found')}</div>
              )}
            <div class="row gx-4 gy-5">
              <div class="col-lg-6">
                <label for="inputEmail4" class="form-label h5 mb-3">
                {t('crm.describe_your_issue')}
                </label>
                <textarea
                  class="form-control rounded-3"
                  id="exampleFormControlTextarea1"
                  placeholder={t('crm.describe_your_issue_here')}
                  rows={5}
                  name="description"
                  onChange={(e) => {
                    let formdata = { ...frmInitialValues };
                    formdata.description = e.target.value;
                    setFrmInitialValues(formdata);
                  }}
                ></textarea>
                {errors.description ? (
                  <div className="error">{errors.description}</div>
                ) : null}
              </div>
              <div class="col-lg-6">
                <label for="inputEmail4" class="form-label h5 mb-3">
                {t('crm.upload_screenshot')}
                </label>
                {/* <input
                  type="file"
                  name=""
                  class="form-control uploadImage-box rounded-3"
                  id=""
                  onChange={uploadImage}
                  accept=".png, .jpg, .jpeg"
                /> */}
                <div class="uploadImage-box rounded-3">
                  <div class="uploadOuter">
                    <label
                      for="uploadFile"
                      class="d-flex flex-column align-items-center"
                    >
                      {uploadedImage && uploadedImage?.screenShot ? (
                        <>
                          <img
                            src={
                              url?.imageUrl + uploadedImage?.screenShot?.default
                            }
                          />
                        </>
                      ) : (
                        <>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="24"
                            viewBox="0 0 20 24"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_2526_67858)">
                              <path
                                d="M19.5214 6.05774V21.4736C19.5214 21.7384 19.4697 22.0006 19.3692 22.2453C19.2687 22.4899 19.1214 22.7122 18.9357 22.8995C18.75 23.0867 18.5296 23.2353 18.287 23.3366C18.0444 23.4379 17.7844 23.4901 17.5218 23.4901H4.54453C4.0142 23.4901 3.50559 23.2776 3.13059 22.8995C2.7556 22.5213 2.54492 22.0084 2.54492 21.4736V13.0811H10.5276V4.99441H2.54492V2.52818C2.54492 1.99338 2.7556 1.48049 3.13059 1.10233C3.50559 0.724168 4.0142 0.511719 4.54453 0.511719H14.1812L14.2314 0.563347L14.1812 0.611996V5.04901C14.1811 5.18152 14.2069 5.31275 14.2571 5.43519C14.3073 5.55763 14.381 5.66889 14.4739 5.76258C14.5668 5.85628 14.6772 5.93058 14.7986 5.98122C14.92 6.03187 15.0501 6.05787 15.1815 6.05774H19.421L19.4722 6.00711L19.5214 6.05774Z"
                                fill="#00ACEA"
                              ></path>
                              <path
                                d="M19.4726 6.00818L19.4214 6.05882H15.18C15.0486 6.05895 14.9185 6.03294 14.797 5.9823C14.6756 5.93165 14.5653 5.85735 14.4724 5.76366C14.3795 5.66996 14.3058 5.55871 14.2556 5.43626C14.2054 5.31382 14.1796 5.18259 14.1797 5.05009V0.615055L14.2299 0.566406L19.4726 6.00818Z"
                                fill="#FEDB41"
                              ></path>
                              <path
                                d="M10.5268 4.99219V13.0789H0.478516V4.99219H10.5268Z"
                                fill="#00EFD1"
                              ></path>
                              <path
                                d="M7.05974 9.12923L6.00038 10.1648V6.69577C6.00038 6.56201 5.94769 6.43372 5.85389 6.33913C5.7601 6.24454 5.63288 6.19141 5.50023 6.19141C5.36758 6.19141 5.24037 6.24454 5.14657 6.33913C5.05278 6.43372 5.00009 6.56201 5.00009 6.69577V10.1658L3.94072 9.13022C3.84467 9.04188 3.71829 8.99472 3.58835 8.99873C3.45841 9.00274 3.33513 9.05762 3.24463 9.15173C3.15413 9.24583 3.10351 9.37178 3.10352 9.50287C3.10352 9.63396 3.15414 9.75991 3.24464 9.85401L5.15367 11.7176C5.24697 11.8087 5.37179 11.8597 5.50171 11.8597C5.63162 11.8597 5.75644 11.8087 5.84974 11.7176L7.7568 9.85302C7.80628 9.8075 7.84619 9.75244 7.87417 9.69108C7.90214 9.62972 7.91761 9.56332 7.91966 9.49582C7.92171 9.42832 7.9103 9.36109 7.8861 9.29812C7.8619 9.23515 7.82541 9.17772 7.77879 9.12924C7.73216 9.08077 7.67636 9.04222 7.61469 9.0159C7.55302 8.98958 7.48673 8.97602 7.41976 8.97601C7.35279 8.97601 7.2865 8.98958 7.22483 9.01589C7.16316 9.04221 7.10637 9.08075 7.05974 9.12923Z"
                                fill="#231F20"
                              ></path>
                              <path
                                d="M5.19741 16.2861H10.3663C10.4989 16.2861 10.6261 16.2329 10.7199 16.1384C10.8137 16.0438 10.8664 15.9155 10.8664 15.7817C10.8664 15.6479 10.8137 15.5197 10.7199 15.4251C10.6261 15.3305 10.4989 15.2773 10.3663 15.2773H5.19741C5.06476 15.2773 4.93755 15.3305 4.84375 15.4251C4.74996 15.5197 4.69727 15.6479 4.69727 15.7817C4.69727 15.9155 4.74996 16.0438 4.84375 16.1384C4.93755 16.2329 5.06476 16.2861 5.19741 16.2861Z"
                                fill="#231F20"
                              ></path>
                              <path
                                d="M4.69727 17.9497C4.69727 18.0834 4.74996 18.2117 4.84375 18.3063C4.93755 18.4009 5.06476 18.454 5.19741 18.454H16.8662C16.9989 18.454 17.1261 18.4009 17.2199 18.3063C17.3137 18.2117 17.3664 18.0834 17.3664 17.9497C17.3664 17.8159 17.3137 17.6876 17.2199 17.5931C17.1261 17.4985 16.9989 17.4453 16.8662 17.4453H5.19741C5.06476 17.4453 4.93755 17.4985 4.84375 17.5931C4.74996 17.6876 4.69727 17.8159 4.69727 17.9497Z"
                                fill="#231F20"
                              ></path>
                              <path
                                d="M16.8662 19.6133H5.19741C5.06476 19.6133 4.93755 19.6664 4.84375 19.761C4.74996 19.8556 4.69727 19.9839 4.69727 20.1176C4.69727 20.2514 4.74996 20.3797 4.84375 20.4743C4.93755 20.5689 5.06476 20.622 5.19741 20.622H16.8662C16.9989 20.622 17.1261 20.5689 17.2199 20.4743C17.3137 20.3797 17.3664 20.2514 17.3664 20.1176C17.3664 19.9839 17.3137 19.8556 17.2199 19.761C17.1261 19.6664 16.9989 19.6133 16.8662 19.6133Z"
                                fill="#231F20"
                              ></path>
                              <path
                                d="M0.479762 13.5632H2.05503V21.4732C2.05424 22.1415 2.31636 22.7829 2.78388 23.2566C3.2514 23.7303 3.88614 23.9976 4.54888 24H17.5251C17.8525 23.9984 18.1764 23.9318 18.4782 23.804C18.78 23.6761 19.0538 23.4895 19.2841 23.2548C19.5143 23.0201 19.6964 22.742 19.82 22.4363C19.9436 22.1306 20.0062 21.8033 20.0042 21.4732V6.05634C20.0076 5.92676 19.9606 5.80097 19.8733 5.70587L14.5351 0.155876C14.4892 0.106752 14.4338 0.067591 14.3723 0.0407893C14.3109 0.0139876 14.2447 0.000108211 14.1777 0L4.54395 0C3.88122 0.0026283 3.24658 0.270234 2.77924 0.744114C2.31191 1.21799 2.05004 1.85945 2.05109 2.52778V4.48765H0.480747C0.416034 4.48814 0.352075 4.50171 0.292646 4.52754C0.233218 4.55337 0.179525 4.59095 0.134739 4.63806C0.0899527 4.68517 0.0549808 4.74085 0.0318885 4.80181C0.00879626 4.86278 -0.00194817 4.92779 0.000289737 4.99301V13.0797C-0.00162576 13.1437 0.00947401 13.2074 0.0329047 13.2669C0.0563353 13.3263 0.0916001 13.3804 0.136525 13.4256C0.181449 13.4708 0.235081 13.5062 0.294114 13.5297C0.353146 13.5532 0.416327 13.5643 0.479762 13.5622V13.5632ZM14.7005 1.75336L18.3433 5.54602H15.181C15.1167 5.54631 15.0531 5.53359 14.9939 5.5086C14.9346 5.48362 14.8809 5.44689 14.836 5.40059C14.7911 5.35428 14.7559 5.29936 14.7324 5.23906C14.709 5.17877 14.6978 5.11434 14.6995 5.0496L14.7005 1.75336ZM3.05237 2.52778C3.05106 2.12673 3.20759 1.74154 3.4876 1.45675C3.76761 1.17196 4.14823 1.01083 4.54592 1.00873H13.7022V5.04861C13.7 5.2456 13.7365 5.44107 13.8097 5.62371C13.883 5.80635 13.9914 5.97252 14.1288 6.11261C14.2661 6.25269 14.4297 6.3639 14.6099 6.4398C14.7902 6.51569 14.9836 6.55476 15.179 6.55475H19.002V21.4732C19.0042 21.6708 18.9677 21.8669 18.8946 22.0503C18.8216 22.2336 18.7133 22.4007 18.5761 22.5418C18.4389 22.6829 18.2755 22.7953 18.0952 22.8726C17.9148 22.9499 17.7211 22.9906 17.5251 22.9923H4.54395C4.14661 22.9896 3.76649 22.8283 3.4869 22.5435C3.20732 22.2588 3.05106 21.8739 3.05237 21.4732V13.5632H10.529C10.6617 13.5689 10.7912 13.5213 10.8892 13.4309C10.9872 13.3404 11.0457 13.2145 11.0518 13.0807V4.99301C11.0464 4.85692 10.989 4.72823 10.8915 4.63399C10.794 4.53974 10.664 4.48729 10.529 4.48765H3.05237V2.52778ZM1.00059 5.49638H10.0505V12.5555H1.00059V5.49638Z"
                                fill="#231F20"
                              ></path>
                            </g>
                            <defs>
                              <clipPath id="clip0_2526_67858">
                                <rect
                                  width="20"
                                  height="24"
                                  fill="white"
                                ></rect>
                              </clipPath>
                            </defs>
                          </svg>
                          <span> {t('crm.please_attach_image_of_issue')}</span>
                        </>
                      )}
                    </label>
                    <input
                      type="file"
                      onChange={uploadImage}
                      ondrop="drop()"
                      id="uploadFile"
                    />
                  </div>
                  <div id="preview"></div>
                </div>
              </div>
            </div>
            <div class="row mt-4 pt-2">
              <div class="col-12">
                <p class="small mb-0">
                {t('crm.any_raise_service_request_will_resolved_within_72_hours')}
                </p>
              </div>
            </div>
            <div class="row mt-5">
              <div class="col-sm-4">
                <div class="d-grid">
                  <button
                    type="submit"
                    class="btn btn-primary btn-arrow"
                    onClick={() => handleSubmit(values)}
                  >
                    {t('crm.submit')}
                  </button>
                </div>
              </div>
              {/* {premiumUser &&
                (
                  <div class="col-sm-4 mt-sm-0 mt-3">
                    <div class="d-grid">
                      <button
                        class="btn btn-gradient"
                        onClick={() => {
                          handlerRequest(values);
                        }}
                      >
                         {t('crm.request_a_callback')}
                      </button>
                    </div>
                  </div>
                )} */}
            </div>
          </Form>
        )}
      </Formik>
     
   
    </div>
  );
};
export default CustomerCareForm;
